import { globalColors } from 'globalStyle';

export const styles = {
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '20px',
  },
  label: {
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '12px',
    color: globalColors.regular.buttons.regularText,
    whiteSpace: 'nowrap',
    marginRight: '10px',
  },
  toggleButtonGroup: {
    height: '30px',
    borderRadius: '4px',
    overflow: 'hidden',
  },
  toggleButton: {
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '14px',
    textTransform: 'none',
    height: '100%',
    padding: '0 14px',
    borderColor: globalColors.regular.buttons.regularBorder,
    color: globalColors.regular.buttons.regularText,
    '&.Mui-selected': {
      backgroundColor: '#2ea1f8',
      color: '#ffffff',
      borderColor: '#2ea1f8',
      '&:hover': {
        backgroundColor: '#2ea1f8',
      },
    },
  },
};
